import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  Grid,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Design = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [roomType, setRoomType] = useState('living');
  const [recommendations, setRecommendations] = useState(null);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axios.get(`${API_URL}/projects`);
      setProjects(response.data.projects || []);
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  const handleGetRecommendations = async () => {
    try {
      const response = await axios.post(`${API_URL}/design/recommendations`, {
        project_id: selectedProject,
        room_type: roomType,
      });
      setRecommendations(response.data.recommendations);
    } catch (error) {
      console.error('Error fetching recommendations:', error);
    }
  };

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Interior Design Recommendations
      </Typography>

      <Card sx={{ mt: 3, p: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Project</InputLabel>
              <Select
                value={selectedProject}
                onChange={(e) => setSelectedProject(e.target.value)}
                label="Select Project"
              >
                {projects.map((project) => (
                  <MenuItem key={project.id} value={project.id}>
                    {project.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Room Type</InputLabel>
              <Select
                value={roomType}
                onChange={(e) => setRoomType(e.target.value)}
                label="Room Type"
              >
                <MenuItem value="living">Living Room</MenuItem>
                <MenuItem value="bedroom">Bedroom</MenuItem>
                <MenuItem value="kitchen">Kitchen</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box mt={3}>
          <Button
            variant="contained"
            onClick={handleGetRecommendations}
            disabled={!selectedProject}
          >
            Get Recommendations
          </Button>
        </Box>
      </Card>

      {recommendations && recommendations.recommendations && (
        <Card sx={{ mt: 3, p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Design Recommendations
          </Typography>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom>
                Color Scheme
              </Typography>
              {JSON.parse(recommendations.recommendations).color_scheme?.map((color, index) => (
                <Typography key={index} variant="body2" sx={{ mb: 1 }}>
                  • {color}
                </Typography>
              ))}
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom>
                Decor Suggestions
              </Typography>
              {JSON.parse(recommendations.recommendations).decor_suggestions?.map((suggestion, index) => (
                <Typography key={index} variant="body2" sx={{ mb: 1 }}>
                  • {suggestion}
                </Typography>
              ))}
            </Grid>
            {JSON.parse(recommendations.recommendations).budget_estimate && (
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  Estimated Budget: ₹{JSON.parse(recommendations.recommendations).budget_estimate.toLocaleString()}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Card>
      )}
    </Container>
  );
};

export default Design;

